import React, { useContext } from 'react';
import Option from './Option'
import { QuestionContext } from './context';
import Answer from './Answer';

function Capital({options, capital, answer}) {
  const [, showAnswers] = useContext(QuestionContext);

  return (
    <div className='px-6 -translate-y-14'>
      <h2 className='font-bold text-slate-600 text-xl'>{capital} is the capital of</h2>
      <ul className='space-y-6 my-6'>
        {/* {options.map((option, index) => {
          return (
            <Option key={index} index={index} text={option} />
          );
        })} */}
        {showAnswers ? 
        options.map((option, index) => {
          return (
            <Answer key={index} index={index} text={option} answer={answer === index} />
          );
        })
        :
        options.map((option, index) => {
          return (
            <Option key={index} index={index} text={option} />
          );
        })
        }
      </ul>
    </div>
  )
}

export default Capital;